import React, { useState, useEffect } from 'react';
import api from '../api'; 
import logoImg from '../assets/logo3.png';
import SiteSwitcher from './SiteSwitcher'; // <--- NEW IMPORT

// Shared Theme Colors
export const THEME = {
    card: '#1e293b', border: '#334155', textSec: '#94a3b8', 
    primary: '#3b82f6', success: '#10b981', danger: '#ef4444', warning: '#facc15',
    bg: '#0f172a'
};

// 2. NEW PROP: onNavigate added
const SaaSLayout = ({ title, sidebar, children, onNavigate }) => {
    const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
    const [sidebarOpen, setSidebarOpen] = useState(false);
    
    // 3. NEW STATE: Notifications
    const [unreadCount, setUnreadCount] = useState(0);

    // Handle Window Resize (Responsive Logic)
    useEffect(() => {
        const handleResize = () => {
            const mobile = window.innerWidth < 768;
            setIsMobile(mobile);
            // If switching to desktop, reset sidebar state
            if (!mobile) setSidebarOpen(false); 
        };
        window.addEventListener('resize', handleResize);
        handleResize(); // Initial check
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    // 4. NEW EFFECT: Fetch Unread Count
    useEffect(() => {
        const fetchNotifications = async () => {
            try {
                // Assuming you have the 'notifications/' endpoint from previous steps
                const res = await api.get('notifications/');
                const count = res.data.filter(n => !n.is_read).length;
                setUnreadCount(count);
            } catch (err) {
                console.error("Failed to fetch notifications");
            }
        };
        
        fetchNotifications();
        
        // Optional: Poll every 60s to keep it fresh
        const interval = setInterval(fetchNotifications, 60000);
        return () => clearInterval(interval);
    }, []);

    // Inline Scrollbar Styling (Works natively in Firefox)
    const scrollStyle = {
        scrollbarWidth: 'thin', 
        scrollbarColor: '#334155 transparent' 
    };

    return (
        <div style={{
            display: 'flex', 
            width: '100vw', 
            height: '100vh', 
            background: THEME.bg, 
            color: 'white', 
            overflow: 'hidden' // Prevents the main window from scrolling
        }}>
            
            {/* --- MOBILE BACKDROP --- */}
            {isMobile && sidebarOpen && (
                <div 
                    onClick={() => setSidebarOpen(false)}
                    style={{
                        position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
                        background: 'rgba(0,0,0,0.5)', zIndex: 40
                    }}
                />
            )}

            {/* --- SIDEBAR --- */}
            <aside style={{
                width: '260px', 
                flexShrink: 0, // Pinned width
                background: '#0f172a',
                borderRight: `1px solid ${THEME.border}`,
                display: 'flex', flexDirection: 'column',
                height: '100%',
                
                // Responsive Positioning
                position: isMobile ? 'fixed' : 'relative',
                left: isMobile && !sidebarOpen ? '-260px' : '0', 
                zIndex: 50,
                transition: 'left 0.3s ease',
                boxShadow: isMobile && sidebarOpen ? '5px 0 15px rgba(0,0,0,0.5)' : 'none'
            }}>
                {/* Brand Header */}
                <div style={{
                    height: '60px', 
                    padding: '0 20px', 
                    borderBottom:`1px solid ${THEME.border}`, 
                    display:'flex', 
                    alignItems:'center', 
                    justifyContent:'space-between', 
                    flexShrink: 0
                }}>
                    <div style={{display:'flex', alignItems:'center', gap:'12px'}}>
                        {/* 1. YOUR LOGO IMAGE */}
                        <img 
                            src={logoImg} 
                            alt="Logo" 
                            style={{height: '35px', width: 'auto', objectFit: 'contain'}} 
                        />
                        
                        {/* 2. WHITE & BLUE TEXT */}
                        <div style={{fontSize:'1.3rem', fontWeight:'bold', letterSpacing: '0.5px'}}>
                            <span style={{color: 'white'}}>Site</span>
                            <span style={{color: '#3b82f6'}}>ACT</span>
                        </div>
                    </div>

                    {isMobile && (
                        <button onClick={() => setSidebarOpen(false)} style={{background:'transparent', border:'none', color:'white', fontSize:'1.2rem'}}>✕</button>
                    )}
                </div>

                {/* Navigation Items (Independent Scroll) */}
                <div style={{
                    flex: 1, 
                    overflowY: 'auto', 
                    padding:'10px',
                    ...scrollStyle 
                }}>
                    {sidebar}
                </div>

                {/* User Footer (Pinned to bottom) */}
                <div style={{padding:'15px', borderTop:`1px solid ${THEME.border}`, background:'#020617', flexShrink: 0}}>
                    <div style={{fontSize:'0.8rem', color:THEME.textSec}}>Logged in as</div>
                    <div style={{fontWeight:'bold'}}>{localStorage.getItem('username') || 'User'}</div>
                </div>
            </aside>

            {/* --- MAIN CONTENT --- */}
            <main style={{
                flex: 1, 
                display: 'flex', 
                flexDirection: 'column', 
                height: '100%', 
                overflow: 'hidden', // Contain scrolling within this panel
                position: 'relative'
            }}>
                
                {/* Header Bar */}
                <header style={{
                    height: '60px', 
                    borderBottom: `1px solid ${THEME.border}`, 
                    display: 'flex', alignItems: 'center', 
                    padding: '0 20px', 
                    background: '#0f172a',
                    flexShrink: 0,
                    zIndex: 30
                }}>
                    <div style={{display:'flex', alignItems:'center', flex: 1}}>
                        {isMobile && (
                            <button 
                                onClick={() => setSidebarOpen(true)}
                                style={{
                                    background: 'transparent', border: 'none', color: 'white', 
                                    fontSize: '1.5rem', cursor: 'pointer', marginRight: '15px'
                                }}
                            >
                                ☰
                            </button>
                        )}
                        <h2 style={{margin:0, fontSize:'1.1rem', color:'white', fontWeight: 600}}>{title}</h2>
                    </div>

                    {/* --- RIGHT SIDE HEADER ITEMS --- */}
                    
                    {/* 1. SITE SWITCHER (Added Here) */}
                    <SiteSwitcher />

                    {/* 2. NOTIFICATION BELL */}
                    <div 
                        onClick={() => onNavigate && onNavigate('profile')} 
                        style={{ position: 'relative', cursor: 'pointer', fontSize: '1.2rem' }}
                        title="Notifications"
                    >
                        🔔
                        {unreadCount > 0 && (
                            <span style={{
                                position: 'absolute', top: -5, right: -5, 
                                background: THEME.danger, color: 'white', 
                                borderRadius: '50%', fontSize: '0.7rem', fontWeight: 'bold',
                                width: '18px', height: '18px', 
                                display: 'flex', alignItems: 'center', justifyContent: 'center',
                                border: '2px solid #0f172a' 
                            }}>
                                {unreadCount > 9 ? '9+' : unreadCount}
                            </span>
                        )}
                    </div>

                </header>

                {/* Scrollable View Area (Independent Scroll) */}
                <div style={{
                    flex: 1, 
                    overflowY: 'auto', 
                    padding: '20px', 
                    background: '#1e293b',
                    ...scrollStyle
                }}>
                    <div style={{maxWidth: '1200px', margin: '0 auto', paddingBottom: '40px'}}>
                        {children}
                    </div>
                </div>
            </main>
        </div>
    );
};

export default SaaSLayout;